import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mb-12 md:mb-16',
    title: 'leading-1.2 mb-1 text-2xl font-normal tracking-[0.8px] md:mb-9.5'
  }
});
